"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _loggers = require("customer-data-tracking/loggers");

var _sampleContacts = require("crm_ui/constants/sampleData/sampleContacts");

var _sampleTimelineEvents = _interopRequireDefault(require("crm_ui/constants/sampleData/sampleTimelineEvents"));

var _SampleTimelineActions = require("crm_data/timeline/SampleTimelineActions");

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var BRIAN_TIMELINE_EVENTS = _sampleTimelineEvents.default.BRIAN;
var COOL_ROBOT_TIMELINE_EVENTS = _sampleTimelineEvents.default.COOL_ROBOT;
var SAMPLE_CONTACT_EVENTS_MAP = {};
SAMPLE_CONTACT_EVENTS_MAP[_sampleContacts.BRIAN.CONTACT_EMAIL] = BRIAN_TIMELINE_EVENTS;
SAMPLE_CONTACT_EVENTS_MAP[_sampleContacts.BRIAN.CONTACT_EMAIL_UID] = BRIAN_TIMELINE_EVENTS;
SAMPLE_CONTACT_EVENTS_MAP[_sampleContacts.COOL_ROBOT.CONTACT_EMAIL] = COOL_ROBOT_TIMELINE_EVENTS;
SAMPLE_CONTACT_EVENTS_MAP[_sampleContacts.COOL_ROBOT.CONTACT_EMAIL_UID] = COOL_ROBOT_TIMELINE_EVENTS;

var injectSampleContactTimelineEvents = function injectSampleContactTimelineEvents(vid, email) {
  var sampleEvents = SAMPLE_CONTACT_EVENTS_MAP[email];

  if (sampleEvents) {
    (0, _SampleTimelineActions.addSampleItems)("" + vid, sampleEvents);
    return _loggers.CrmLogger.logCRMOnboarding(_ObjectTypes.CONTACT, {
      experiment: 'sample contact v3',
      step: 'shown sample timeline items'
    });
  }

  return null;
};

var _default = injectSampleContactTimelineEvents;
exports.default = _default;
module.exports = exports.default;